import { render, staticRenderFns } from "./EventHighlights.vue?vue&type=template&id=9df1f31e&scoped=true"
import script from "./EventHighlights.vue?vue&type=script&lang=js"
export * from "./EventHighlights.vue?vue&type=script&lang=js"
import style0 from "./EventHighlights.vue?vue&type=style&index=0&id=9df1f31e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df1f31e",
  null
  
)

export default component.exports